import { Box, Grid, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import InfoItem from 'modules/procurement/components/InfoItem'

import type { PurchaseOrder } from '../types'

interface Props {
  purchaseOrder: PurchaseOrder
}

const PaymentInfo: React.FC<Props> = ({ purchaseOrder }) => {
  let paymentMethodText = ''

  switch (purchaseOrder.preferredPaymentMethod) {
    case 'virtualcard':
      paymentMethodText = i18n.t(
        'procurement.purchase_orders.detail.payment.payment_types.single_use_card'
      )
      break

    case 'banktransfer':
      paymentMethodText = i18n.t(
        'procurement.purchase_orders.detail.payment.payment_types.bank_transfer'
      )
      break

    case 'cash':
      paymentMethodText = i18n.t(
        'procurement.purchase_orders.detail.payment.payment_types.manual_payment'
      )
  }

  return (
    <Box gap="s12">
      <Text weight="bold" size="200" color="grey800" caps>
        {i18n.t('procurement.purchase_orders.detail.payment.title')}
      </Text>
      <Grid variant="fixed">
        <Box gridColSpan={{ xxs: 6 }}>
          <InfoItem
            label={i18n.t('procurement.purchase_orders.detail.payment.payment_types.title')}
            item={
              <Box flexDirection="row" gap="s8">
                <Text weight="medium" size="300" color="grey1000">
                  {paymentMethodText}
                </Text>
              </Box>
            }
          />
        </Box>
        {purchaseOrder.preferredPaymentMethod === 'virtualcard' && purchaseOrder.card?.last4 && (
          <Box gridColSpan={{ xxs: 6 }}>
            <InfoItem
              label={i18n.t('procurement.purchase_orders.detail.payment.pay_from_account')}
              textItem={`•••• ${purchaseOrder.card.last4}`}
            />
          </Box>
        )}
        {purchaseOrder.preferredPaymentMethod === 'banktransfer' && (
          <Box gridColSpan={{ xxs: 6 }}>
            <InfoItem
              label={i18n.t('procurement.purchase_orders.detail.payment.send_payment_to')}
              textItem={`•••• ${purchaseOrder.vendor?.iban?.slice(-4)}`}
            />
          </Box>
        )}
      </Grid>
    </Box>
  )
}

export default PaymentInfo
